import { Card, CardContent, Typography, Box, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";

export default function QuizCard({ quiz, onTrain }) {
  const theme = useTheme();
  const maxStars = 3;

  const gradientPool = [
    theme.custom.gradients.bluePurple,
    theme.custom.gradients.purplePink,
    theme.custom.gradients.aws,
    theme.custom.gradients.kubernetes,
  ];

  const background =
    gradientPool[
      quiz.id
        .split("")
        .reduce((sum, c) => sum + c.charCodeAt(0), 0) %
        gradientPool.length
    ];

  const lastScore = quiz.lastScores?.at(-1);
  const previousScores = quiz.lastScores?.slice(0, -1) ?? [];


  const getScoreStyle = (score, isLast = false) => ({
    background:
      score >= 80
        ? "linear-gradient(135deg, #2ecc71, #27ae60)"
        : "linear-gradient(135deg, #e74c3c, #c0392b)",
    color: "#fff",
    fontWeight: isLast ? 900 : 600,
    fontSize: isLast ? "1.6rem" : "0.75rem",
    px: isLast ? 3 : 1,
    py: isLast ? 1.2 : 0.4,
    borderRadius: isLast ? "999px" : 1,
    boxShadow: isLast
      ? "inset 0 0 0 2px rgba(255,255,255,0.25)"
      : "none",
    opacity: isLast ? 1 : 0.75,
  });

  return (
    <Card
      onClick={() => onTrain(quiz.id)}
      sx={{
        cursor: "pointer",
        width: 260,
        aspectRatio: "3 / 3",
        background,
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 4,
        position: "relative",
        overflow: "hidden",
        transition: "all 0.3s ease",
        boxShadow: theme.custom.shadow.soft,
        "&:hover": {
          transform: "translateY(-8px)",
          boxShadow: theme.custom.shadow.strong,
        },
      }}
    >
      {/* Glow overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at top, rgba(255,255,255,0.25), transparent 60%)",
          pointerEvents: "none",
        }}
      />

      <CardContent
        sx={{
          p: 2.5,
          width: "100%",
          textAlign: "center",
          zIndex: 1,
        }}
      >
        <Typography
          variant="subtitle1"
          fontWeight={800}
          sx={{ letterSpacing: 0.8, mb: 0.5 }}
        >
      {quiz.id.toUpperCase()}
        </Typography>

        {/* Difficulty */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
          {Array.from({ length: maxStars }).map((_, index) =>
            index < quiz.difficulty ? (
              <StarIcon
                key={index}
                sx={{ color: "#FFD54F", fontSize: 20 }}
              />
            ) : (
              <StarBorderIcon
                key={index}
                sx={{ color: "rgba(255,255,255,0.6)", fontSize: 20 }}
              />
            )
          )}
        </Box>

        {quiz.lastScores?.length > 0 && (
          <Stack spacing={1.2} alignItems="center" sx={{ mt: 1 }}>
            <Typography
              variant="body2"
              sx={{ opacity: 0.85, fontWeight: 600 }}
            >
              Dernier résultat 
            </Typography>

            {/* Last score */}
            {lastScore !== undefined && (
              <Box sx={getScoreStyle(lastScore, true)}>
                {lastScore}%
              </Box>
            )}

            {/* Previous scores */}
            {previousScores.length > 0 && (
              <Stack
                direction="row"
                spacing={0.6}
                justifyContent="center"
                sx={{ mt: 0.5 }}
              >
                {previousScores.map((score, index) => (
                  <Box
                    key={index}
                    sx={getScoreStyle(score)}
                  >
                    {score}%
                  </Box>
                ))}
              </Stack>
            )}

            {/* Status */}
            <Typography
              variant="caption"
              sx={{
                mt: 0.5,
                fontWeight: 700,
                opacity: 0.9,
              }}
            >
            </Typography>
          </Stack>
        )}
      </CardContent>
    </Card>
  );
}
